var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPushpin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.625 10.2612C12.625 9.85 12.3275 9.5175 11.925 9.40375C10.8138 9.0975 10 8.0825 10 6.875V2.5H10.875C11.3563 2.5 11.75 2.10625 11.75 1.625C11.75 1.14375 11.3563 0.75 10.875 0.75H2.125C1.64375 0.75 1.25 1.14375 1.25 1.625C1.25 2.10625 1.64375 2.5 2.125 2.5H3V6.875C3 8.0825 2.18625 9.0975 1.075 9.40375C0.6725 9.5175 0.375 9.85 0.375 10.2612V10.375C0.375 10.8563 0.76875 11.25 1.25 11.25H5.6075L5.625 17.375C5.625 17.8563 6.01875 18.25 6.5 18.25C6.98125 18.25 7.375 17.8563 7.375 17.375L7.3575 11.25H11.75C12.2313 11.25 12.625 10.8563 12.625 10.375V10.2612Z",
    fill: "#163567"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushpin);
export default __webpack_public_path__ + "static/media/pushpin.c228b45a9bb3484910492fbc0b412ac8.svg";
export { ForwardRef as ReactComponent };